export default __webpack_public_path__ + "./image/9f7bf973dc885e8c8e0e3e7df0a53073.png";